import { useMemo } from 'react';
import { ProductChargingMode, ProductPricing } from '@mews-commander/data-access';
import { useServiceProducts } from '@mews-commander/legacy-entities/src/utils/useServiceProducts';
import { AddProductsForm } from './AddProductsForm';

export const AddProductsToReservationPanelBody: React.FC<{ serviceId: string }> = ({ serviceId }) => {
    const serviceProducts = useServiceProducts(serviceId);

    // For now only products charged once with absolute pricing are displayed
    const chargedOnceProducts = useMemo(
        () =>
            serviceProducts.filter(
                ({ chargingMode, pricing }) =>
                    chargingMode === ProductChargingMode.Once && pricing.discriminator === ProductPricing.Absolute
            ),
        [serviceProducts]
    );

    return <AddProductsForm products={chargedOnceProducts} />;
};
